import { Component, OnInit } from '@angular/core'
import { EventService, TranslationService, WindowRef } from '@spartacus/core'
import { CurrentProductService, ProductIntroComponent } from '@spartacus/storefront'
import { Observable, tap } from 'rxjs'
import { ICustomProduct } from '../../../models/interface/product.interface'
import { ProductDetailsService } from '../../../services/product.service'
import { CustomProductReplacementService } from '../custom-product-replacement/custom-product-replacement.service'

@Component({
    selector: 'app-custom-product-intro',
    templateUrl: './custom-product-intro.component.html',
    styleUrls: ['./custom-product-intro.component.scss'],
    standalone: false
})
export class CustomProductIntroComponent extends ProductIntroComponent implements OnInit {
  public productDetails$: Observable<ICustomProduct>
  public isProductDiscontinuedInRegion: boolean = false

  constructor(
    protected currentProductService: CurrentProductService,
    translationService: TranslationService,
    protected winRef: WindowRef,
    eventService: EventService,
    private productDetailsService: ProductDetailsService,
    private customProductReplacementService: CustomProductReplacementService
  ) {
    super(currentProductService, translationService, winRef, eventService)
  }

  ngOnInit(): void {
    this.productDetails$ = this.productDetailsService
      .getProductDetail()
      .pipe(
        tap(
          (currentProduct) =>
            (this.isProductDiscontinuedInRegion =
              this.customProductReplacementService.isDiscontinuedRegion(currentProduct))
        )
      )
  }
}
